export default "__VITE_ASSET__DOWkqfSk__"